import TransactionsSuccessModal from './TransactionsSuccessModal';
export default TransactionsSuccessModal;
